<!--
     <TimeEvent
       :props="my_attrs_dictionary"
       @bind="my_bind_handler"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - id [REQUIRED] → This instance id.
     - tipo_periodo_id [REQUIRED] → The id of a period type select to watch
     - incluye_findes_id → The id of a select { 0: no weekends, 1: weekends }
     - value
     - label
     - placeholder
     - required
     - readonly
     - min_days
     - max_days
-->

<template>
  <div>
    <!-- Period type is NUMERIC -->
    <v-text-field
      v-if="period_is_numeric"
      v-model="numeric_value"
      size="4"
      :label="props.label"
      :class="[
        props.class || props.readonly ? 'qmkey-form-input-readonly': 'qmkey-form-input',
        { required: props.required }
      ]"
      :placeholder="props.placeholder"
      :readonly="props.readonly"
      :disabled="!!props.disabled || !!props.readonly"
      @click:append="increment"
      @click:prepend="decrement"
      outlined
      dense
      @change="enforce_min_max"
      background-color="#f2f2f2"
      :rules="[only_nums, is_required, is_in_range, is_integer]"
      @update:error	="error_state"
      >
      <template slot="append-outer" v-if="!props.readonly && !props.disabled">
        <v-icon
          @click="increment"
          color="primary"
          :disabled="props.readonly"
          >
          {{ false || 'mdi-plus' }}
        </v-icon>
      </template>
      <template slot="prepend" v-if="!props.readonly && !props.disabled">
        <v-icon
          color="primary"
          @click="decrement"
          :disabled="props.readonly"
        >
          {{ false || 'mdi-minus' }}
        </v-icon>
      </template>
    </v-text-field>

    <!-- Period type is SELECT -->
    <v-select
      v-if="period_is_select"
      v-model="select_value"
      :items="select_items"
      :label="props.label"
      :placeholder="props.placeholder"
      multiple
      item-value="value"
      item-text="text"
      :rules="[is_required]"
      :class="[
        props.class || props.readonly ? 'qmkey-form-input-readonly': 'qmkey-form-input',
        { required: props.required }
      ]"
      outlined
      dense
      :disabled="!!props.disabled || !!props.readonly"
      @change="update_value"
    >
    </v-select>
  </div>
</template>


<script>
 import { mapGetters } from 'vuex'

 export default {
   name: 'TimeEvent',

   props: ['props','form_values'],

   data: () => ({
     numeric_value: null,
     allow_weekends: false,
     select_value: null,
     week_days: ['monday','tuesday','wednesday','thursday', 'friday'],
     weekend_days: ['saturday', 'sunday'],
     valid: true,
   }),

   computed: {
     ...mapGetters(['sitePath']),

     value() {
       if (this.period_is_numeric)
         return this.numeric_value;
       else if (this.period_is_select)
         return this.select_value;
       return null;
     },

     period_type() {
      return this.form_values.tipo_periodo || null;
     },


     period_is_numeric() {
       return "dsmy".indexOf(this.period_type) >= 0;
     },

     period_is_select() {
       return this.period_type == 'w';
     },

     week() {
      return this.week_days.map(day => this.$vuetify.lang.translator('week_days.' + day));
     },

     weekend() {
      return this.weekend_days.map(day => this.$vuetify.lang.translator('week_days.' + day));
     },

     select_items() {
       // Backend needs numeric value not week day name !!
       //  let week = this.week;
       let week = [
         {value: 0, text: this.$vuetify.lang.translator('week_days.monday')},
         {value: 1, text: this.$vuetify.lang.translator('week_days.tuesday')},
         {value: 2, text: this.$vuetify.lang.translator('week_days.wednesday')},
         {value: 3, text: this.$vuetify.lang.translator('week_days.thursday')},
         {value: 4, text: this.$vuetify.lang.translator('week_days.friday')},
       ];
       if (this.allow_weekends) {
         // week.append(this.weekend);
         week.push({value: 5, text: this.$vuetify.lang.translator('week_days.saturday')});
         week.push({value: 6, text: this.$vuetify.lang.translator('week_days.sunday')});
       }
       return week;      
     }
   },

   mounted() {
    this.allow_weekends = this.props.incluye_findes_id;
   },

   methods: {
     validate() {
       // TODO: Show error message
       return !this.props.required || !!this.value
     },

     update_period_type(period_type) {
       this.enforce_min_max();
     },

     update_weekends(allow) {
       this.allow_weekends = (allow > 0);
     },

     approx_value_to_days(val) {
       // Returns -1 if unable to determinate
       if (this.period_type == 'd')
         return val;
       else if (this.period_type == 's')
         return val * 7;
       else if (this.period_type == 'm')
         return val * (365.25/12);
       else if (this.period_type == 'y')
         return val * 365.25;
       return -1;
     },

     approx_days_to_value(days) {
       // Returns days if unable to determinate
       if (this.period_type == 'd')
         return days;
       else if (this.period_type == 's')
         return days / 7;
       else if (this.period_type == 'm')
         return days / (365.25/12);
       else if (this.period_type == 'y')
         return days / 365.25;
       return days;
     },

     increment() {
       this.numeric_value++;
       this.enforce_min_max();
     },

     decrement() {
       this.numeric_value--;
       this.enforce_min_max();
     },

     enforce_min_max() {
       if (!this.numeric_value || !this.valid) {
        return
      };
      this.numeric_value = parseInt(this.numeric_value);
       let approx_days = this.approx_value_to_days(this.numeric_value);
       if (this.props.min_days && approx_days < this.props.min_days) {
         this.numeric_value = Math.ceil(this.approx_days_to_value(this.props.min_days));
       } else if (this.props.max_days && approx_days > this.props.max_days) {
         this.numeric_value = Math.ceil(this.approx_days_to_value(this.props.max_days));
        }
      this.update_value(this.numeric_value);
     },

     error_state(ok) {
       this.valid = !ok
     },

     update_value(value) {
      this.$emit('update', value);
     },

    only_nums(value) {
      return !isNaN(value) || this.$vuetify.lang.translator('invalid_value')
    },

    is_integer(value) {
      return Number.isInteger(+value) || this.$vuetify.lang.translator('invalid_value')
    },

    is_in_range(value) {
      // Min and Max limits are in days. Aprox. 20 years
      if (!value && value !== 0) return true;
      
      let approx_days = this.approx_value_to_days(+value);
      let v = true
      if (this.props.min_days === 0 || this.props.min_days)      
        v =
          approx_days >= this.props.min_days ||
          this.$vuetify.lang.translator('bigger_than') + ' ' + (Math.ceil(this.approx_days_to_value(this.props.min_days - 1)))
      if (v === true && (this.props.max_days === 0 || this.props.max_days))
        v =
          approx_days <= this.props.max_days ||
          this.$vuetify.lang.translator('smaller_than') + ' ' + (Math.ceil(this.approx_days_to_value(this.props.max_days + 1)))
      return v || this.$vuetify.lang.translator('invalid_value')
    },

    is_required(value) {
      if (value === 0) return true
      return !!value || !this.props.required || this.$vuetify.lang.translator('required_field')
    },
   },
   watch: {
    period_type() {
      if (this.period_is_numeric) {
        this.enforce_min_max();
      }else{
        this.update_value(this.select_value);
      }      
    }
   }
 }
</script>
<style lang="scss">
 @import '@/sass/modalform.scss';
</style>
